import { render, staticRenderFns } from "./SessionDetails.vue?vue&type=template&id=90601a8c"
import script from "./SessionDetails.vue?vue&type=script&lang=js"
export * from "./SessionDetails.vue?vue&type=script&lang=js"
import style0 from "./SessionDetails.vue?vue&type=style&index=0&id=90601a8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports